// Phase 1A Phase 9C.2 — Reserve icon definitions.
//
// 7 reserve glyphs. Disk-with-modifier vocabulary — never money bags,
// never wallets, never coin stacks. Pool A / B / C identity is in
// the reserve-registry labels; icons are visual category indicators.

import type { IconDef } from "./icon-types.ts";

export const RESERVE_ICONS: Record<string, IconDef> = {
  "reserve.active_stake": {
    // Pool A — full disk (in play).
    key: "reserve.active_stake",
    shapes: [{ type: "circle", cx: 12, cy: 12, r: 6, filled: true }],
  },
  "reserve.bankroll_pool": {
    // Pool B — ringed protected disk.
    key: "reserve.bankroll_pool",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 8 },
      { type: "circle", cx: 12, cy: 12, r: 4, filled: true },
    ],
  },
  "reserve.investment_seed": {
    // Pool C — disk with arrow up (long-horizon seed).
    key: "reserve.investment_seed",
    shapes: [
      { type: "circle", cx: 12, cy: 14, r: 5 },
      { type: "line", x1: 12, y1: 14, x2: 12, y2: 5 },
      { type: "polyline", points: "9,8 12,5 15,8" },
    ],
  },
  "reserve.crypto_reserve": {
    // Disk with chain-link inside.
    key: "reserve.crypto_reserve",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7.5 },
      { type: "path", d: "M9 11 A2 2 0 0 1 11 13 A2 2 0 0 1 9 15" },
      { type: "path", d: "M15 13 A2 2 0 0 1 13 11 A2 2 0 0 1 15 9" },
    ],
  },
  "reserve.forex_reserve": {
    // Disk with wave inside.
    key: "reserve.forex_reserve",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7.5 },
      { type: "path", d: "M7 12 Q9.5 9 12 12 T17 12" },
    ],
  },
  "reserve.cash_buffer": {
    // Striped bar (idle reserve, paused energy).
    key: "reserve.cash_buffer",
    shapes: [
      { type: "rect", x: 4, y: 9, width: 16, height: 6, rx: 1 },
      { type: "line", x1: 8, y1: 9, x2: 8, y2: 15 },
      { type: "line", x1: 12, y1: 9, x2: 12, y2: 15 },
      { type: "line", x1: 16, y1: 9, x2: 16, y2: 15 },
    ],
  },
  "reserve.emergency_pause": {
    // Pause bars (operations halted).
    key: "reserve.emergency_pause",
    shapes: [
      { type: "rect", x: 7, y: 6, width: 3.5, height: 12, rx: 0.6, filled: true },
      { type: "rect", x: 13.5, y: 6, width: 3.5, height: 12, rx: 0.6, filled: true },
    ],
  },
};
